<div class="row balance">
  <div class="col-2 col-md-1 col-lg-5 balance-cred">
    <h3>{{ planInfo?.globalSignaturesRemainments }}</h3>
  </div>

  <div class="col-9 col-md-3 col-lg-5 balance-word">
    <h6>Créditos Restantes</h6>
  </div>
</div>
